import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { Product } from '@app/administration/ord/models/product';
import { RsFormatFile } from '@rs-shared-lib/models/rs-format-file';
import { rsFormatFile } from '@lib/utils/custom-rxjs-operators/rsFormatFile';

@Injectable()
export class ProductService {

  constructor(
    private readonly http: HttpClient
  ) {
  }

  public getProducts(): Observable<Product[]> {
    return this.http.get<Product[]>(
      `${environment.apiUrl}/product`
    );
  }

  public downloadProductTermsConditions(productId: number): Observable<HttpResponse<Blob>> {
    return this.http.get<HttpResponse<Blob>>(`${environment.apiUrl}/product/${productId}/terms-and-conditions`, {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json'
    });
  }

  public downloadProductLogo(productId: number): Observable<RsFormatFile> {
    return this.http.get(`${environment.apiUrl}/product/${productId}/logo`, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(rsFormatFile());
  }

  public createProduct(
    body: CreateProductRequest,
    documentFile: File,
    logoFile: File
  ): Observable<void> {

    const formData: FormData = new FormData();

    formData.append('logo', logoFile);
    formData.append('terms-and-conditions', documentFile);
    formData.append(
      'data',
      new Blob([JSON.stringify(body)], { type: 'application/json' })
    );

    return this.http.post<void>(
      `${environment.apiUrl}/product`,
      formData
    );
  }

  public updateProduct(productId: number, body: Product, logoFile: File): Observable<void> {
    const formData: FormData = new FormData();

    if (logoFile) {
      formData.append('logo', logoFile);
    }
    formData.append(
      'data',
      new Blob([JSON.stringify(body)], { type: 'application/json' })
    );

    return this.http.post<void>(
      `${environment.apiUrl}/product/${productId}`,
      formData
    );
  }

  public generateProductDeliveryReceipt(body: CreateProductRequest, logoFile: File): Observable<RsFormatFile> {
    const formData: FormData = new FormData();

    const data = {
      defaultProduct: body.defaultProduct,
      logoName: body.logoName,
      referenceCode: body.referenceCode
    };

    formData.append('logo', logoFile);
    formData.append(
      'data',
      new Blob([JSON.stringify(data)], { type: 'application/json' })
    );

    return this.http.post(
      `${environment.apiUrl}/product/delivery-receipt-mockup`,
      formData,
      {
        observe: 'response',
        responseType: 'blob'
      }
    ).pipe(rsFormatFile());
  }

}

export interface CreateProductRequest {
  defaultProduct: boolean;
  logoName: string;
  referenceCode: string;
  termsAndConditionsName: string;
}
